module.exports = __webpack_public_path__ + "static/media/by.731a61b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/by.svg
// module id = 1435
// module chunks = 0